import React from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';

import HomeCheckerApplyButton from '../../../common/components/HomeCheckerApplyButton';

import './Apply.scss';

const Apply = () => (
  <div className="wrapper">
    <Heading
      size="large"
      text={trans('home-checker.apply.title')}
      className="mb-xl"
    />

    <p className="apply__description">
      {trans('home-checker.apply.description')}
    </p>

    <p className="apply__action">
      <HomeCheckerApplyButton />
    </p>
  </div>
);

export default Apply;
